"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var hex_1 = require("../hex");

var encodeHelpers_1 = require("./encodeHelpers");

function encode(params, args) {
  var result = null;

  if (params.length === args.length) {
    var parts = [];
    var dynamicParts = [];
    var offset = params.length * 32;

    for (var i = 0; i < params.length; i += 1) {
      var type = params[i].type;
      var value = args[i];
      var encoded = encodeHelpers_1.encodeArg({
        type: type,
        value: value
      }, false);

      if (type === 'string' || type === 'bytes' || type.endsWith('[]')) {
        parts.push(hex_1.padHexLeft(hex_1.toHex(offset), 32));
        dynamicParts.push(encoded);
        offset += hex_1.getHexBytesSize(encoded);
      } else {
        parts.push(encoded);
      }
    }

    result = hex_1.concatHex.apply(hex_1, parts.concat(dynamicParts));
  }

  return result;
}

exports.encode = encode;